import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'
import * as yup from 'yup'

export default function OrganizationNameInput() {
  const createMemberInfo = useFormContext()
  const classes = useBoldInputStyle()
  const {t} = useTranslation()
  const schema = yup.object().shape({
    code: yup.string(),
  })

  const {
    formState: {errors},
  } = useFormContext()

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel} style={{padding: '5px 0'}}>
          {t('IInstituteName')}
        </p>
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: 5}}>
        <div style={{width: '100%'}}>
          <input
            placeholder={t('IRegisterHospitalName')}
            className={classes.input}
            style={{width: '100%'}}
            {...createMemberInfo.register('orgName', {
              validate: (code) =>
                schema.validate({code}).catch((e) => e.errors[0]),
            })}
          />
        </div>
      </div>
      {errors.orgName && (
        <span className={classes.errorText}>
          {errors.orgName && errors.orgName.message}
        </span>
      )}
    </div>
  )
}
